// Mobile navigation toggle
document.querySelectorAll('.menu-toggle').forEach(function (toggle) {
  toggle.addEventListener('click', function () {
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
});

// Image slideshow with auto-rotation, arrows, and dots
document.querySelectorAll('[data-slideshow]').forEach(function (root) {
  var slides = Array.prototype.slice.call(root.querySelectorAll('.slideshow__slide'));
  if (slides.length === 0) return;
  var dots = Array.prototype.slice.call(root.querySelectorAll('.slideshow__dot'));
  var autoplay = root.getAttribute('data-autoplay') === 'true';
  var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
  var index = 0;
  var timer = null;

  function show(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach(function (slide, n) {
      slide.classList.toggle('is-active', n === index);
    });
    dots.forEach(function (dot, n) {
      dot.classList.toggle('is-active', n === index);
      dot.setAttribute('aria-current', n === index ? 'true' : 'false');
    });
  }

  function start() {
    if (!autoplay || slides.length < 2) return;
    stop();
    timer = setInterval(function () { show(index + 1); }, interval);
  }

  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  var prev = root.querySelector('.slideshow__arrow--prev');
  var next = root.querySelector('.slideshow__arrow--next');
  if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
  if (next) next.addEventListener('click', function () { show(index + 1); start(); });
  dots.forEach(function (dot, n) {
    dot.addEventListener('click', function () { show(n); start(); });
  });

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);

  show(0);
  start();
});
